import { render, staticRenderFns } from "./RolledUpJournalReport.vue?vue&type=template&id=2a989687&scoped=true&"
import script from "./RolledUpJournalReport.vue?vue&type=script&lang=js&"
export * from "./RolledUpJournalReport.vue?vue&type=script&lang=js&"
import style0 from "./RolledUpJournalReport.vue?vue&type=style&index=0&id=2a989687&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a989687",
  null
  
)

export default component.exports